<template>
  <validation-observer
    ref="messageStepObs"
    tag="form"
    @submit.prevent="stepSubmit">
    <v-row>
      <v-col
        cols="12"
        class="d-flex pb-0">
        <validation-provider
          v-slot="{ errors }"
          name="วิธีการส่งข้อความ"
          rules="required">
          <div class="mt-n5 d-flex ml-4">
            <v-checkbox
              v-for="(type, index) in textTypes"
              :key="index"
              v-model="form.type"
              :label="type.label"
              :value="type.value"
              :readonly="!editable"
              class="mx-2" />
            <p class="error-message error--text mt-6">
              {{ errors[0] }}
            </p>
          </div>
        </validation-provider>
      </v-col>
      <v-col
        cols="12"
        class="pb-0">
        <validation-provider
          v-slot="{ errors }"
          name="ข้อความ"
          rules="required">
          <v-textarea
            v-model="form.text"
            :readonly="!editable"
            label="พิมพ์ข้อความ"
            :error-messages="errors[0]"
            outlined
            @click="setCurrentCursorPos($event)"
            @input="previewPersonalize($event)" />
        </validation-provider>
      </v-col>
      <v-col
        v-if="editable"
        cols="12"
        class="d-flex flex-wrap pt-0">
        <div
          v-for="(item, index) in variables"
          :key="index"
          class="ma-2">
          <v-btn
            small
            @click="addPersonalWordToTextField(item.value)">
            {{ item.label }}
          </v-btn>
        </div>
      </v-col>
      <v-col
        class="pt-0"
        cols="12">
        <v-textarea
          class="text-preview-box"
          readonly
          outlined>
          <template v-slot:prepend-inner>
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div v-html="previewText" />
          </template>
        </v-textarea>
      </v-col>
      <v-col
        cols="12">
        <v-divider />
        <h4 class="mt-6">
          IMAGES & IMAGEMAPS
        </h4>
        <div class="img-row d-inline-flex">
          <div
            v-for="(imgField, index) in form.img"
            :key="index"
            class="preview-container mx-4">
            <div
              v-if="editable"
              class="close-img-field-btn"
              @click="removeImgField(index)">
              X
            </div>
            <div class="img-container">
              <img
                :src="`${imgField.img}/1040`"
                class="img-preview">
            </div>
            <validation-provider
              v-slot="{ errors }"
              name="URL"
              :rules="{regex: /^https:\/\//}">
              <v-text-field
                v-model="imgField.actionUri"
                label="URL"
                :readonly="!editable"
                :error-messages="errors[0]" />
            </validation-provider>
          </div>
          <div
            v-if="form.img.length < imgLimit && editable"
            class="upload-container mx-4">
            <validation-provider
              v-slot="{ errors }"
              name="IMG"
              rules="size:10000">
              <upload-file
                accept="image/png, image/jpeg, image/jpg"
                @input="uploadImgHandle" />
              <div class="text-caption text-center mt-2">
                {{ errors[0] || '1040px Recommend' }}
              </div>
            </validation-provider>
          </div>
        </div>
      </v-col>
      <v-col
        cols="12"
        class="d-flex">
        <v-divider />
      </v-col>
      <v-col
        cols="12"
        class="d-flex">
        <v-checkbox
          v-model="form.itemInCart"
          :readonly="!editable"
          value="addToCart"
          class="ml-4"
          label="Item in cart" />
      </v-col>
      <v-col
        cols="12"
        class="d-flex">
        <v-divider />
      </v-col>
      <v-col
        cols="12">
        <div class="ml-4">
          <carousel @input="carouselInput" />
        </div>
      </v-col>
      <v-col
        cols="12"
        class="d-flex">
        <v-spacer />
        <v-btn
          v-if="editable"
          color="primary"
          type="submit">
          ยืนยัน
        </v-btn>
      </v-col>
    </v-row>
  </validation-observer>
</template>

<script>
import { mapActions } from 'vuex'
import PersonalizeMutator from '@/utils/personlizeMutator'
import UploadFile from '@/components/form/UploadFile.vue'
import Carousel from '@/views/Promotions/components/messaging/Carousel'

export default {
  components: {
    UploadFile,
    Carousel
  },
  props: {
    oldMsg: {
      type: Object,
      default: () => ({
        type: [],
        text: '',
        img: [],
        itemInCart: [],
        carousel: []
      })
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    textHint1: '$firstName = ชื่อจริง, $lastName = นามสกุล, $tel = เบอร์โทรศัพท์, $code = โปรโมชั่นโค้ด, $spending = ยอดซื้อสะสม',
    textHint2: '$memberType = ประเภทสมาชิก, $discount = ส่วนลด, $codeExpire = วันหมดอายุโค้ด, $birthDate = วันเดือนปีเกิด',
    form: {
      type: [],
      text: '',
      img: [],
      itemInCart: [],
      carousel: []
    },
    textTypes: [
      { label: 'LINE', value: 'line' },
      { label: 'SMS', value: 'sms' }
    ],
    imgLimit: 4,
    previewText: '',
    currentCursorPos: {
      start: 0,
      end: 0
    },
    variables: [
      {
        label: 'ชื่อจริง',
        value: '$firstName'
      },
      {
        label: 'นามสกุล',
        value: '$lastName'
      },
      {
        label: 'เบอร์โทร',
        value: '$tel'
      },
      {
        label: 'ประเภทสมาชิก',
        value: '$memberType'
      },
      {
        label: 'วันเกิด',
        value: '$birthDate'
      },
      {
        label: 'โปรโมชั่นโค้ด',
        value: '$code'
      },
      {
        label: 'วันหมดอายุโค้ดส่วนลด',
        value: '$expireCode'
      },
      {
        label: 'ส่วนลดโปรโมชั่นโค้ด',
        value: '$discount'
      },
      {
        label: 'ยอดซื้อสะสม',
        value: '$spending'
      }
    ]
  }),
  watch: {
    oldMsg: {
      handler (val) {
        this.form = val
        this.previewPersonalize(this.form.text)
      },
      deep: true
    }
  },
  mounted () {
    this.initMessage()
  },
  methods: {
    ...mapActions({
      setSnackBar: 'Style/setSnackbar'
    }),
    initMessage () {
      this.form = this.oldMsg
      this.previewPersonalize(this.form.text)
    },
    addPersonalWordToTextField (insert) {
      this.form.text = this.mergeText(insert)
      this.previewPersonalize(this.form.text)
    },
    mergeText (insert) {
      return this.form.text + insert
    },
    setCurrentCursorPos (event) {
      this.currentCursorPos = {
        start: event.target.selectionStart,
        end: event.target.selectionEnd
      }
    },
    previewPersonalize (text) {
      const temp = text || ''
      this.previewText = this.personalizing(temp)
    },
    personalizing (text) {
      let result = text
      this.variables.forEach((variable) => {
        const sampleValue = variable.value.replace('$', '')
        if (PersonalizeMutator[sampleValue]) {
          result = result.replaceAll(variable.value, PersonalizeMutator[sampleValue]())
        }
      })

      return result
    },
    removeImgField (index) {
      this.form.img.splice(index, 1)
    },
    uploadImgHandle (img) {
      const baseUrl = `${process.env.VUE_APP_S3_URL}${img[0].Key.replace('/240', '')}`
      this.form.img.push({ img: baseUrl })
    },
    hasLineMethod () {
      const lineCheck = this.form.type.some((type) => type === 'line')
      if (!lineCheck && this.form.img.length !== 0) {
        this.form.type.push('line')
      }
    },
    async stepSubmit () {
      try {
        const validated = await this.$refs.messageStepObs.validate()
        if (validated) {
          this.hasLineMethod()
          this.$emit('input', { message: this.form }, 3)
        } else {
          this.$emit('validated-failure')
          this.setSnackBar({
            value: true,
            message: 'กรุณากรอกฟอร์มให้ถูกต้องและครบถ้วน',
            type: 'warning'
          }, 3)
        }
      } catch (e) {
        this.setSnackBar({
          value: true,
          message: `มีบางอย่างไม่ถูกต้อง (${e.message})`,
          type: 'error'
        })
      }
    },
    stepBack () {
      this.$emit('step-back')
    },
    carouselInput (val) {
      this.form.carousel = val
    }
  }
}
</script>

<style scoped>
.text-preview-box {
  white-space: pre-wrap;
}

.error-message {
  font-size: 11px;
}

.upload-container {
  width: 20%;
  height: 168px;
}

.preview-container {
  width: 20%;
  height: 168px;
  position: relative;
}

.preview-container input {
  font-size: 12px;
}

.preview-container .img-container {
  display: flex;
  height: 98px;
}

.preview-container .img-preview {
  align-self: center;
  margin-bottom: 36px;
  width: 100%;
}

.preview-container .close-img-field-btn{
  font-size: 16px;
  position: absolute;
  width: 24px;
  height: 24px;
  color: white;
  background-color: black;
  text-align: center;
  cursor: pointer;
  right: 0px;
  top: 0px;
}

.img-row {
  width: 100%;
  margin-top: 32px;
  margin-left: 12px;
}
</style>
